if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.viewer      = this.querySelector('.pgallery__viewer');
        this.slides      = this.querySelectorAll('.pgallery__slide');
        this.thumbs      = this.querySelectorAll('.pgallery__thumb');
        this.scrollFill  = this.querySelector('.pgallery__scroll-fill');
        this.navPrev     = this.querySelector('.pgallery__nav--prev');
        this.navNext     = this.querySelector('.pgallery__nav--next');
        this.swiper      = null;
        this.mql         = window.matchMedia('(min-width: 990px)');

        this._initThumbs();
        this._initNavArrows();
        this._updateSwiper();
        this.mql.addEventListener('change', () => this._updateSwiper());
      }

      _initThumbs() {
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            this.setActiveMedia(thumb.dataset.mediaId, false);
          });
        });
      }

      _initNavArrows() {
        if (this.navPrev) {
          this.navPrev.addEventListener('click', () => {
            const idx = this._activeIndex();
            if (idx > 0) this.setActiveMedia(this.slides[idx - 1].dataset.mediaId, false);
          });
        }
        if (this.navNext) {
          this.navNext.addEventListener('click', () => {
            const idx = this._activeIndex();
            if (idx < this.slides.length - 1) this.setActiveMedia(this.slides[idx + 1].dataset.mediaId, false);
          });
        }
      }

      _activeIndex() {
        return [...this.slides].findIndex((s) => s.classList.contains('is-active'));
      }

      _updateSwiper() {
        if (this.mql.matches) {
          // Desktop: destroy Swiper, CSS + class control visibility
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        } else {
          // Mobile: init Swiper
          if (!this.swiper && typeof Swiper !== 'undefined') {
            this._initSwiper();
          }
        }
      }

      _initSwiper() {
        const initialSlide = Math.max(0, this._activeIndex());

        this.swiper = new Swiper(this.viewer, {
          slidesPerView: 1,
          loop: false,
          threshold: 5,
          initialSlide,
          on: {
            slideChange: (swiper) => {
              const slide = swiper.slides[swiper.activeIndex];
              if (slide) {
                this._syncThumb(slide.dataset.mediaId);
                this._updateScrollBar(swiper.activeIndex, swiper.slides.length);
              }
            },
          },
        });

        // Set initial scroll bar position
        this._updateScrollBar(initialSlide, this.slides.length);
      }

      _updateScrollBar(index, total) {
        if (!this.scrollFill) return;
        const pct = total <= 1 ? 100 : (index / (total - 1)) * 100;
        this.scrollFill.style.width = `${pct}%`;
      }

      /* Called by product-info.js on variant change */
      setActiveMedia(mediaId, prepend) {
        this._syncThumb(mediaId);

        const slideIndex = [...this.slides].findIndex(
          (s) => s.dataset.mediaId === mediaId
        );
        if (slideIndex === -1) return;

        if (this.swiper) {
          this.swiper.slideTo(slideIndex);
        } else {
          this.slides.forEach((s) => s.classList.remove('is-active'));
          this.slides[slideIndex].classList.add('is-active');
        }
      }

      _syncThumb(mediaId) {
        this.thumbs.forEach((t) => {
          t.classList.toggle('is-active', t.dataset.mediaId === mediaId);
        });

        const active = this.querySelector('.pgallery__thumb.is-active');
        if (active) {
          active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }
    }
  );
}
